import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import XLSX from 'xlsx'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import moment from "moment-timezone";
import NotificationIcon from '../../common/components/NotificationIcon';
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import _, { get } from "lodash";
import { useHistory, useLocation } from "react-router-dom";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import GetAppIcon from '@material-ui/icons/GetApp';
import ReturnRequestPopup from './ReturnRequestPopup';
import ReturnAllRequestPopup from './ReturnAllRequestPopup';
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Menu, MenuItem, Tooltip } from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import WarningIcon from "@material-ui/icons/Warning";
import Error from '@material-ui/icons/Error';
import { Close } from '@material-ui/icons';
import { Carousel } from 'react-bootstrap';
import RejectPopup from './RejectPopup';
import { updateReturnStatus, viewReturnOrderAPI } from '../../store/actions/delivery.actions';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  actionButtons: {
    display: 'flex',
    gap: 16,
    marginTop: 24,
    marginBottom: 24,
  },
  actionButton: {
    color: '#1A9FE0',
  },
  headerSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
  },
  pageTitle: {
    fontSize: '1.75rem',
    fontWeight: 700,
    fontFamily: 'Nunito',
    color: '#1a1a1a',
    margin: 0,
  },
  iconGroup: {
    marginLeft: 'auto',
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  invoiceHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 14,
  },
  invoiceInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  invoiceId: {
    fontSize: '1.125rem',
    fontWeight: 700,
    fontFamily: 'Nunito',
    color: '#1a1a1a',
    margin: 0,
  },
  invoiceDate: {
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    color: '#140c0cff',
    margin: 0,
    fontWeight: 600,
    paddingTop: 6
  },
  headerActions: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  backButton: {
    color: '#1A9FE0',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  exportButton: {
    backgroundColor: 'transparent',
    color: '#1A9FE0',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    textTransform: 'none',
    padding: '6px 16px',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#f0f9ff',
    },
  },
  grossValue: {
    fontSize: '1rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#1a1a1a',
    margin: 0,
  },
  tableContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  tableHeader: {
    backgroundColor: '#ffffff',
  },
  headerCell: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.75rem',
    textAlign: 'center',
    fontFamily: 'Nunito',
    borderBottom: '2px solid #e0e0e0',
    padding: '16px',
    whiteSpace: 'nowrap',
  },
  headerCell1: {
    color: '#133F8A',
    fontWeight: 900,
    textAlign: 'center',
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    backgroundColor: '#f2f2f2',
    borderBottom: '2px solid #e0e0e0',
    padding: '16px',
    whiteSpace: 'nowrap',
  },
  subHeaderText: {
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    color: '#161212ff',
    marginTop: 4,
  },
  subHeaderText1: {
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    color: '#161212ff',
    marginTop: 4,
  },
  bodyCell: {
    color: '#666666',
    fontWeight: 600,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Nunito',
    borderBottom: '1px solid #f0f0f0',
    padding: '16px',
  },
  submittedBodyCell: {
    color: '#5d0996ff',
    fontWeight: 600,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Nunito',
    borderBottom: '1px solid #f0f0f0',
    padding: '16px',
  },
  bodyCell1: {
    color: '#666666',
    fontWeight: 600,
    fontSize: 12,
    fontFamily: 'Nunito',
    borderBottom: '1px solid #f0f0f0',
    padding: '16px',
    backgroundColor: '#f2f2f2',
    textAlign: 'center'
  },
  cancelButton: {
    backgroundColor: 'transparent',
    color: '#D32F2F',
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    fontWeight: 600,
    textTransform: 'none',
    padding: '6px 10px',
    borderRadius: 16,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
  },
  buttonSection: {
    display: 'flex',
    alignItems: "center",
    justifyContent: 'space-between',
  },
  actionButtons1: {
    display: 'flex',
    gap: 16,
  },
  paginationContainer: {
    borderTop: '1px solid #e0e0e0',
  },
  returnRequestedRow: {
    backgroundColor: 'white !important',
  },
}));

const PdfPreview = ({ url, name }: { url: string; name: string }) => {
  const [src, setSrc] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let objectUrl = '';
    let cancelled = false;
    setSrc('');
    setError(false);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new window.Error('Failed to load file');
        return res.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  const messageStyle: React.CSSProperties = {
    height: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: 500,
  };

  if (error) return <div style={messageStyle}>Preview not available. Please use Download.</div>;
  if (!src) return <div style={messageStyle}>Loading...</div>;

  return (
    <iframe
      src={src}
      title={name}
      style={{ width: "100%", height: "500px", border: "none", borderRadius: "8px" }}
    />
  );
};

export default function SalesReturnRequestDetails() {
  const classes = useStyles();
  const history = useHistory()
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;
  const dispatch: Dispatch<any> = useDispatch();
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [loading, setLoading] = React.useState<any>(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");
  const [showReturnRequestPopup, setShowReturnRequestPopup] = React.useState<boolean>(false);
  const [showAllReturnRequestPopup, setShowAllReturnRequestPopup] = React.useState<boolean>(false);
  const { viewDelivery, billingDetails, deleteReturnRequestDetails, getReturnOrderDetails, viewReturnOrderAPIDetails }: any = useSelector((state: any) => state.delivery);
  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const InoviceDate = sessionStorage.getItem("reorder-InoviceDate");
  const isQualityCheckPending =
    (sessionStorage.getItem("returnOrderStatus") || "").trim().toLowerCase() === "quality check pending"; // NEW  const isFSE = sessionStorage.getItem('userType') === 'FSE';
  const [returnRequests, setReturnRequests] = React.useState<any>({});
  const [selectedReturnItem, setSelectedReturnItem] = React.useState<any>(null);
  const [etag, setEtag] = React.useState<any>("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openRejectDialog, setOpenRejectDialog] = useState<boolean>(false);
  const [rejectMode, setRejectMode] = useState<'single' | 'all' | 'partial'>('single');
  const [selectedPartNo, setSelectedPartNo] = useState<string>('');
  const [returnQty, setReturnQty] = useState<number>(0);
  const [currentItem, setCurrentItem] = useState<any>(null);
  const [partialApprovalMap, setPartialApprovalMap] = useState<{ [key: string]: { approvedQty: number; reason: string } }>({});
  const [rejectionReasonMap, setRejectionReasonMap] = useState<{ [key: string]: string }>({});
  const [approveQty, setApproveQty] = useState<string>('');
  const [rejectionReason, setRejectionReason] = useState<string>('');
  const [showProceedDialog, setShowProceedDialog] = React.useState<boolean>(false);

  const [selectedImages, setSelectedImages] = useState<
    { url: string; name: string }[]
  >([]);
  const [activeIndex, setActiveIndex] = useState(0);

  // Get invoice data from billingDetails
  const invoiceData = billingDetails?.data?.data || null;
  const invoiceId = invoiceData?.data?.invoiceId;
  const returnOrderData = viewReturnOrderAPIDetails?.data?.data || null;

  // To check sapLineItemStatus is empty
  const dataSource = returnOrderData?.data || invoiceData?.data?.itemDetails || [];
  const isSapStatusEmpty = !selectedReturnItem?.sapLineItemStatus || selectedReturnItem?.sapLineItemStatus?.trim?.() === '';
  const allItemsHaveSapStatus = dataSource?.every?.((item: any) => item?.sapLineItemStatus && item?.sapLineItemStatus?.trim?.() !== '') || false;

  useEffect(() => {
    if (invoiceId) {
      const savedData = sessionStorage.getItem(`returnRequests_${invoiceId}`);
      if (savedData) {
        try {
          const parsedData = JSON.parse(savedData);
          setReturnRequests(parsedData);
        } catch (error) {
          console.error('Error loading auto-saved data:', error);
        }
      }
    }
  }, [invoiceId]);

  useEffect(() => {
    if (invoiceId && Object.keys(returnRequests).length > 0) {
      sessionStorage.setItem(`returnRequests_${invoiceId}`, JSON.stringify(returnRequests));
    }
  }, [returnRequests, invoiceId]);

  const exportInvoice = () => {
    const dataSource = returnOrderData?.data || invoiceData?.data?.itemDetails;

    if (dataSource && dataSource.length > 0) {
      let filename = `Invoice - ${returnOrderData?.invoiceNumber || 'ReturnOrder'}.xlsx`;
      let data: any = [];

      dataSource.map((item: any) => {
        data.push({
          'Part No.': item.materialNumber || '-',
          'Description': item.description || '-',
          'Delivered Qty': item.deliveredQty || 0,
          'Returned Qty': item.returnedQty || '-',
          'Return Reason': item.reason || '-',
          'Unit Price (Excl. VAT)': item.netPrice ? item.netPrice.toFixed(2) : '-',
          'Net Value (Excl. VAT)': item.netValue ? item.netValue.toFixed(2) : '-',
          'Return Qty - Requested': item.returnQty || '-',
          'Return Qty - Approved': item.approvedQty || '-',
          'Return Net Value (Excl. VAT)': item.returnNetValue ? item.returnNetValue.toFixed(2) : '-',
          'Status': item.status || '-'
        });
        return undefined;
      });

      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, filename);
    }
  };
  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const handleRejectAllPopup = () => {
    // Reset any per-item state so Reject All always starts with a blank form
    setSelectedReturnItem(null);
    setApproveQty('');
    setRejectionReason('');
    setReturnQty(0);
    setSelectedPartNo('');
    setRejectMode('all');
    setOpenRejectDialog(true);
  };

  const handleRejectAll = async (reason: string) => {
    const payload = {
      rejectAll: true,
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      returnOrderNumber: returnOrderNo,
      reason: reason,
      updatedBy: userName,
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      }
    }
    try {
      const response: any = await dispatch(updateReturnStatus(payload));
      if (response?.data) {
        setSuccessMessage('Return request rejected successfully');
        setOpenSnackbar(true);
        setOpenRejectDialog(false);
        // Call the API again to refresh the details
        await ViewReturnOrderRequest("reject");

      } else {
        setShowErrorMessage(response?.error || 'Failed to reject return request');
        setOpenErrorSnackbar(true);
      }
    } catch (error: any) {
      setShowErrorMessage(error?.message || 'An error occurred while rejecting the request');
      setOpenErrorSnackbar(true);
    }
  }

  const handleProceed = async () => {
    setShowProceedDialog(false);
    setLoading(true);

    const payloadForQualityCheck = {
      sentForQualityCheck: true,
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      returnOrderNumber: returnOrderNo,
      updatedBy: userName,
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      }
    };

    try {
      const qualityCheckResponse: any = await dispatch(updateReturnStatus(payloadForQualityCheck));

      if (qualityCheckResponse?.status === 200 || qualityCheckResponse?.data) {
        setSuccessMessage(typeof qualityCheckResponse?.data === 'string' ? qualityCheckResponse?.data : 'Return request sent for quality check successfully');
        setOpenSnackbar(true);
        // Redirect after 2 seconds
        setTimeout(() => {
          history.push('/returnrequest');
        }, 2000);
      } else {
        setShowErrorMessage(typeof qualityCheckResponse?.error === 'string' ? qualityCheckResponse?.error : 'Failed to send return request for quality check');
        setOpenErrorSnackbar(true);
      }
    } catch (error: any) {
      setShowErrorMessage(error?.message || 'An error occurred while sending the request for quality check');
      setOpenErrorSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleReturnSuccess = (materialNumber: string, returnData: any, responseEtag?: string) => {
    const item = invoiceData?.data?.itemDetails.find((i: any) => i.materialNumber === materialNumber);
    const returnNetValue = item ? (item.netPrice * returnData.returnQty) : 0;

    setReturnRequests((prev: any) => ({
      ...prev,
      [materialNumber]: {
        ...returnData,
        returnNetValue: returnNetValue,
        status: 'requested'
      }
    }));

    if (responseEtag) {
      setEtag(responseEtag);
    }

    setShowReturnRequestPopup(false);
    setSelectedRow(null);
    setSelectedReturnItem(null);
  };

  const getTotalReturnValue = () => {
    if (returnOrderData?.totalReturnValue && returnOrderData.totalReturnValue > 0) {
      return returnOrderData.totalReturnValue;
    }

    if (invoiceData?.data?.totalReturnValue && invoiceData.data.totalReturnValue > 0) {
      return invoiceData.data.totalReturnValue;
    }

    return Object.values(returnRequests).reduce((sum: number, request: any) => {
      return sum + (request.returnNetValue || 0);
    }, 0);
  };

  const returnOrderNo = returnOrderData?.returnOrderNo || null;

  const getReturnHistoryForItem = (materialNumber: string) => {
    return invoiceData?.data?.returnHistoryList?.find(
      (history: any) => history.materialNumber === materialNumber
    );
  };


  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {

    setApproveQty('');
    setRejectionReason('');
    setReturnQty(0);
    setSelectedPartNo('');

    setAnchorEl(event.currentTarget);
    setSelectedReturnItem(item);
    // setSelectedPartNumber(item.partNumber);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
    setCurrentItem(null);
  };

  const ViewReturnOrderRequest = async (status: any) => {
    setLoading(true);

    const payload = {
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      orderNumber: returnOrderNo,
      sapCustomerId: selectedReturnItem?.sapCustomerId || returnOrderData?.sapCustomerId,
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
      },
      role: sessionStorage.getItem('userType-Profile-API')
    };

    let responseData: any = await dispatch(viewReturnOrderAPI(payload));
    if (responseData && responseData.status === 400) {
      setOpenErrorSnackbar(true);
      handleopenCloseErrorSnackbar(true);
      setShowErrorMessage(typeof responseData?.error === 'string' ? responseData?.error : 'Unable to get return order');
      setLoading(false);
    } else {
      setOpenErrorSnackbar(false);
      handleopenCloseSnackbar(true);
      setSuccessMessage(
        status === "approve" ? 'Return request approved successfully' :
          status === "partiallyapprove" ? 'Return request partially approved successfully' :
            status === "reject" ? 'Return request rejected successfully' :
              'Return request updated successfully'
      );
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    if (!selectedReturnItem) return;

    const payload = {
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      returnOrderNumber: returnOrderNo,
      materialNumber: selectedReturnItem.materialNumber,
      itemId: selectedReturnItem.itemId,
      status: "Approved",
      approvedQty: selectedReturnItem.returnQty,
      updatedBy: userName,
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      }
    };

    try {
      const response: any = await dispatch(updateReturnStatus(payload));
      if (response?.data) {
        setSuccessMessage('Return request approved successfully');
        setOpenSnackbar(true);
        // Call the API again to refresh the details
        await ViewReturnOrderRequest("approve");
      } else {
        setShowErrorMessage(response?.error || 'Failed to approve return request');
        setOpenErrorSnackbar(true);
      }
    } catch (error: any) {
      setShowErrorMessage(error?.message || 'An error occurred while approving the request');
      setOpenErrorSnackbar(true);
    }
    handleCloseAnchor();
  };

  const handlePartialApprove = async (reason: string, approveQty: number) => {
    if (!selectedReturnItem) return;

    const payload = {
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      returnOrderNumber: returnOrderNo,
      materialNumber: selectedReturnItem.materialNumber,
      itemId: selectedReturnItem.itemId,
      status: "Partially Approved",
      approvedQty: approveQty,
      reason: reason.trim(),
      updatedBy: userName,
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      }
    };

    try {
      const response: any = await dispatch(updateReturnStatus(payload));
      if (response?.data) {
        setPartialApprovalMap(prev => ({
          ...prev,
          [selectedReturnItem.itemId]: {
            approvedQty: approveQty,
            reason: reason.trim()
          }
        }));

        setSuccessMessage('Return request partially approved successfully');
        setOpenSnackbar(true);
        // Call the API again to refresh the details
        await ViewReturnOrderRequest("partiallyapprove");
        handleCloseAnchor();
        setOpenRejectDialog(false);
      } else {
        setShowErrorMessage(response?.error || 'Failed to partially approve return request');
        setOpenErrorSnackbar(true);
      }
    } catch (error: any) {
      setShowErrorMessage(error?.message || 'An error occurred while partially approving the request');
      setOpenErrorSnackbar(true);
    }
    handleCloseAnchor();
  };

  const handleReject = async (reason: string, approveQty: number) => {
    if (!selectedReturnItem) return;

    const payload = {
      invoiceNumber: invoiceData?.data?.invoiceId || returnOrderData?.invoiceNumber,
      returnOrderNumber: returnOrderNo,
      materialNumber: selectedReturnItem.materialNumber,
      itemId: selectedReturnItem.itemId,
      status: "Rejected",
      approvedQty: 0,
      reason: reason.trim(),
      updatedBy: userName,
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      }
    };

    try {

      const response: any = await dispatch(updateReturnStatus(payload));

      if (response?.data) {
        setRejectionReasonMap(prev => ({
          ...prev,
          [selectedReturnItem.itemId]: reason.trim()
        }));

        setSuccessMessage('Return request rejected successfully');
        setOpenSnackbar(true);
        // Call the API again to refresh the details
        await ViewReturnOrderRequest("reject");
        handleCloseAnchor();
        setOpenRejectDialog(false);
      }
      else {
        setShowErrorMessage(response?.error || 'Failed to reject return request');
        setOpenErrorSnackbar(true);
      }
    } catch (error: any) {
      setShowErrorMessage(error?.message || 'An error occurred while rejecting the request');
      setOpenErrorSnackbar(true);
    }
    handleCloseAnchor();
  };

  const handlePartialApproveClick = (item: any) => {
    const updatedItem = {
      ...item,
      rejectionReason: '',
      approvedQty: ''

    };
    setSelectedReturnItem(updatedItem);
    setRejectMode('partial');
    setSelectedPartNo(item.materialNumber);
    setOpenRejectDialog(true);

  };

  const handleRejectClick = (item: any) => {
    const updatedItem = {
      ...item,
      rejectionReason: ''
    };
    setSelectedReturnItem(updatedItem);

    setRejectMode('single');
    setSelectedPartNo(item.materialNumber);
    setOpenRejectDialog(true);
  };

  type StatusType = "Approved" | "Partially Approved" | "Rejected";

  const getStatusColor = (status: StatusType) => {
    switch (status) {
      case "Approved":
        return "#4caf50";
      case "Partially Approved":
        return "#e6a23c";
      case "Rejected":
        return "#d32f2f";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const getFileType = (name: string = ''): 'image' | 'pdf' | 'doc' | 'other' => {
    const ext = name.split('.').pop()?.toLowerCase() || '';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
    if (ext === 'pdf') return 'pdf';
    if (['doc', 'docx'].includes(ext)) return 'doc';
    return 'other';
  };

  const handleIconClick = (imagesObj: any) => {
    setActiveIndex(0);
    if (!imagesObj) {
      setSelectedImages([]);
      setOpenDialog(true);
      return;
    }
    const imagesArray = Object.values(imagesObj)
      .flat()
      .map((img: any) => ({
        url: img.url,
        name: img.name
      }))
      .filter((img: any) => getFileType(img.name) !== 'other');

    setSelectedImages(imagesArray);
    setOpenDialog(true);
  };

  const handleDownload = async (image: { url: string; name: string }) => {
    try {
      const response = await fetch(image.url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = image.name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error("Download failed", error);
    }
  };

  return (
    <div className={classes.root}>
      {loading && <FullscreenLoader />}
      {viewReturnOrderAPIDetails && viewReturnOrderAPIDetails.loading && <FullscreenLoader />}

      <Snackbar
        open={openSnackbar}
        message={successMessage}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        message={showErrorMessage}
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} />
      <div className="d-flex align-items-center mt-2 mb-4">
        <div>
          <h2 className="page-title" style={{ marginBottom: 4 }}>Sales Return Details</h2>
          <p className="px-1" style={{
            fontSize: '0.875rem',
            fontFamily: 'Nunito',
            color: '#140c0cff',
            fontWeight: 600,
            margin: 0
          }}>
            Order No: {returnOrderNo || '-'}
          </p>
        </div>
        <div className="ml-auto">
          <AnnouncementIcon />
          <NotificationIcon />
        </div>
      </div>
      <div className={classes.invoiceHeader}>
        <div className={classes.invoiceInfo}>
          <p className={classes.invoiceId}>Invoice No: {returnOrderData?.invoiceNumber || '-'}</p>
          <p className={classes.invoiceDate}>
            Date:{' '}
            {InoviceDate
              ? moment(InoviceDate)
                .tz('Asia/Dubai')
                .format('DD MMM YYYY')
              : '-'}
          </p>
        </div>
        <div className={classes.headerActions}>
          <IconButton onClick={() => { history.push(`/returnrequest`) }} className={`ml-auto ${classes.actionButton}`}>
            <ChevronLeftIcon fontSize="small" />
            <span className="backLinkLabel px-2">Back</span>
          </IconButton>
          {/* <Button
            className={classes.exportButton}
            startIcon={<GetAppIcon />}
            onClick={() => exportInvoice()}
            disabled={
              (!returnOrderData || !returnOrderData.data || returnOrderData.data.length === 0) &&
              (!invoiceData || !invoiceData.data?.itemDetails || invoiceData.data.itemDetails.length === 0)
            }
          >
            Export to Excel
          </Button> */}
        </div>
      </div>
      {/* Table */}
      <div className={classes.tableContainer}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                {/* <TableCell className={`${classes.headerCell}`} style={{ width: 100 }}>
                                    Part No.
                                </TableCell> */}
                <TableCell className={`${classes.headerCell}`} style={{ width: 100 }}>
                  <div className='pb-2'> SN.</div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={`${classes.headerCell}`} style={{ width: 100 }}>
                  <div className='pb-2'> Part No.</div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 180 }}>
                  <div className='pb-2'> Description </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                  <div className='pb-2'> Delivered Qty </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                  <div>Net Price</div>
                  <div className={classes.subHeaderText}>(Excl. VAT)</div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                  <div>Net Value</div>
                  <div className={classes.subHeaderText}>(Excl. VAT)</div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                  <div className='pb-2'> Return Qty </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                  <div>Return Net Value</div>
                  <div className={classes.subHeaderText}>(Excl. VAT)</div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 120 }}>
                  <div className='pb-2'> Return Reason </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                  <div className='pb-2'> Status </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
                <TableCell className={classes.headerCell} style={{ width: 100 }}>
                  <div className='pb-2'> Action </div>
                  <div className={classes.subHeaderText}></div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
                if (dataSource && dataSource.length > 0) {
                  return dataSource
                    .map((item: any, index: number) => {
                      // Check if return request exists in local state
                      const returnData = returnRequests[item.materialNumber];
                      const hasReturnFromAPI = item.returnNetValue && item.returnNetValue > 0;
                      const isReturnRequested = !!returnData || hasReturnFromAPI;

                      // Get the display values - prioritize API data over local state
                      const displayReturnQty = item.returnQty || returnData?.returnQty || '-';
                      const displayApprovedQty = item.approvedQty || '-';
                      const displayReturnNetValue = item.returnNetValue || returnData?.returnNetValue || null;
                      const displayStatus = item.status || (returnData ? 'Requested' : '-');

                      return (
                        <TableRow
                          key={index}
                          className={isReturnRequested ? classes.returnRequestedRow : ''}
                        >
                          <TableCell className={classes.bodyCell}>{index + 1}</TableCell>
                          <TableCell className={classes.bodyCell}>{item.materialNumber || '-'}</TableCell>
                          <TableCell className={classes.bodyCell}>{item.description || '-'}</TableCell>
                          <TableCell className={classes.bodyCell} align="center">
                            {item.deliveredQty || 0}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="center">
                            {item.netPrice || '-'}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="right">
                            {item.netValue ? item.netValue.toFixed(2) : '-'}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="right">
                            {item.returnQty || '-'}
                          </TableCell>
                          <TableCell className={classes.bodyCell} align="center">
                            {displayReturnNetValue ? displayReturnNetValue.toFixed(2) : '-'}
                          </TableCell>
                          <TableCell
                            className={classes.bodyCell}
                            align="center"
                            style={{
                              width: 200,
                              maxWidth: 200,
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >

                              <Tooltip title={item?.reason || "No return reason"} arrow>
                                <Error
                                  style={{
                                    color: "#1a9fe0",
                                    cursor: "pointer",
                                    fontSize: "28px",
                                  }}
                                  onClick={() => console.log("Reason clicked")}
                                />
                              </Tooltip>

                              <ImageIcon
                                style={{
                                  color: "#1a9fe0",
                                  cursor: "pointer",
                                  fontSize: "28px",
                                }}
                                onClick={() => handleIconClick(item?.returnImages)}
                              />
                            </div>
                          </TableCell>
                          <TableCell
                            className={classes.bodyCell}
                            align="center"
                            style={{ fontWeight: "bold", color: getStatusColor(displayStatus) }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                              <span style={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                                lineHeight: '1.4',
                                wordWrap: 'break-word'
                              }}>
                                {displayStatus}
                              </span>

                              {displayStatus === "Partially Approved" ? (
                                <Error
                                  style={{
                                    color: "#1a9fe0",
                                    cursor: "pointer",
                                    fontSize: "28px",
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexShrink: 0
                                  }}
                                  onClick={() => {
                                    setSelectedReturnItem(item);
                                    setRejectMode('partial');
                                    setSelectedPartNo(item.materialNumber);
                                    setReturnQty(item.returnQty);
                                    setApproveQty(item.approvedQty.toString());
                                    setRejectionReason(item.rejectionReason);
                                    setOpenRejectDialog(true);
                                  }}
                                />
                              ) : null}

                              {displayStatus === "Rejected" ? (
                                <Error
                                  style={{
                                    color: "#1a9fe0",
                                    cursor: "pointer",
                                    fontSize: "28px",
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexShrink: 0
                                  }}
                                  onClick={() => {
                                    setSelectedReturnItem(item);
                                    setRejectMode('single');
                                    setSelectedPartNo(item.materialNumber);
                                    setRejectionReason(item.rejectionReason);
                                    setOpenRejectDialog(true);
                                  }}
                                />
                              ) : null}

                            </div>
                          </TableCell>
                          <TableCell>
                            <div style={{ background: "white", textAlign: "center" }}>
                              <IconButton
                                onClick={(event: any) => {
                                  setApproveQty('');
                                  setRejectionReason('');
                                  setReturnQty(0);
                                  handleMenuOpen(event, item);
                                }}
                                className={classes.actionButton}
                                size="small"
                                disabled={isQualityCheckPending}
                              >
                                <div className="px-2 pt-1 pb-1 boxshadow-icon">
                                  <MoreVertIcon fontSize="inherit" className={classes.actionButton} />
                                </div>
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    });
                } else {
                  return (
                    <TableRow>
                      <TableCell colSpan={10} align="center" className={classes.bodyCell}>
                        Sales Return Details are unavailable.
                      </TableCell>
                    </TableRow>
                  );
                }
              })()}
            </TableBody>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseAnchor}
              keepMounted
              anchorReference="anchorEl"
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className="mt-5 px-2"
              PaperProps={{
                style: {
                  maxHeight: '300px',
                  overflow: 'auto',
                  position: 'fixed'
                }
              }}
            >
              <MenuItem className='px-3' style={{ paddingTop: 2, paddingBottom: 2 }} disabled={!isSapStatusEmpty} >
                <Button
                  className="text-info px-2"
                  // startIcon={<EditOutlinedIcon />}
                  onClick={async () => {
                    // setIsEdit(true);
                    // handleClickOpen();
                    // const data: any = await dispatch(editAnnexurePart(selectedPartNumber));
                    // if (data?.error) {
                    //   setSuccessMessage(typeof data?.error === 'string' ? data?.error : data?.error?.error ? data?.error?.error : 'Error Occured');
                    //   handleopenCloseErrorSnackbar(true);
                    // }

                    handleApprove();
                    handleCloseAnchor();
                  }}
                  disabled={!isSapStatusEmpty}
                >
                  <div className="font-dropdown" style={{ color: "#4caf50" }}>Approve</div>
                </Button>
              </MenuItem>

              <MenuItem style={{ paddingTop: 2, paddingBottom: 2 }} disabled={!isSapStatusEmpty || selectedReturnItem?.returnQty === "1" || selectedReturnItem?.returnQty === 1}>
                <Button
                  className="text-info px-2"
                  onClick={() => {
                    handleCloseAnchor();
                    handlePartialApproveClick(selectedReturnItem);
                  }}
                  disabled={!isSapStatusEmpty || selectedReturnItem?.returnQty === "1" || selectedReturnItem?.returnQty === 1}
                >
                  <div className="font-dropdown" style={{ color: "#e6a23c" }}>Partially Approve</div>
                </Button>
              </MenuItem>

              <MenuItem style={{ paddingTop: 2, paddingBottom: 2 }} disabled={!isSapStatusEmpty}>
                <Button
                  className="text-info px-2"
                  // startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                  onClick={() => {
                    handleCloseAnchor();
                    handleRejectClick(selectedReturnItem);
                  }}
                  disabled={!isSapStatusEmpty}
                >
                  <div className="font-dropdown" style={{ color: "#d32f2f" }}>Reject</div>
                </Button>
              </MenuItem>
            </Menu>
          </Table>
          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Grid container justifyContent="space-between" alignItems="center">
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {selectedImages.length > 0
                    ? selectedImages[activeIndex]?.name?.replace(/\.[^.]+$/, "")
                    : "Return Part"}
                </div>
                <IconButton onClick={() => setOpenDialog(false)}>
                  <Close style={{ color: "#000" }} />
                </IconButton>
              </Grid>
            </DialogTitle>
            <DialogContent className="wempopup">
              {selectedImages.length === 0 ? (

                <div style={{
                  height: "200px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px",
                  fontWeight: 500
                }}>
                  No images available
                </div>

              ) : (
                <Carousel indicators={false}
                  interval={null}
                  prevLabel=""
                  nextLabel=""
                  onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}>

                  {selectedImages.map((img, idx) => {
                    const fileType = getFileType(img.name);
                    return (
                      <Carousel.Item key={idx}>
                        <div style={{ height: "500px", textAlign: "center" }}>
                          {fileType === 'image' && (
                            <img
                              src={img.url}
                              alt={img.name}
                              className="d-block w-full h-96 mx-auto object-contain"
                              style={{
                                width: "100%",
                                height: "500px",
                                objectFit: "cover",
                                borderRadius: "8px"
                              }}
                            />
                          )}

                          {fileType === 'pdf' && <PdfPreview url={img.url} name={img.name} />}

                          {fileType === 'doc' && (
                            <iframe
                              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(img.url)}`}
                              title={img.name}
                              style={{ width: "100%", height: "500px", border: "none", borderRadius: "8px" }}
                            />
                          )}
                        </div>
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              )}
            </DialogContent>
            <DialogActions style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "16px"
            }}>
              <div className="float-left">
                <Button
                  onClick={() => handleDownload(selectedImages[activeIndex])}
                  color="primary"
                  variant="contained"
                  disabled={selectedImages.length === 0}
                  style={{
                    borderRadius: "25px", padding: "8px 24px",
                    opacity: selectedImages.length === 0 ? 0.5 : 1
                  }}
                >
                  Download Image
                </Button>
              </div>
              <Button onClick={() => setOpenDialog(false)} variant="contained" style={{ borderRadius: "25px", padding: "8px 24px" }}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </TableContainer>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "30px",
          marginTop: "15px"
        }}
      >

        <Button
          variant="contained"
          disabled={allItemsHaveSapStatus || isQualityCheckPending}
          style={{
            borderRadius: "25px",
            backgroundColor: "#e0e0e0",
            color: "black",
            padding: "6px 20px"
          }}
          onClick={handleRejectAllPopup}
        >
          Reject All
        </Button>

        <Button
          variant="contained"
          color="primary"
          disabled={allItemsHaveSapStatus || isQualityCheckPending}
          style={{
            borderRadius: "25px",
            padding: "6px 20px"
          }}
          onClick={() => setShowProceedDialog(true)}
        >
          Proceed
        </Button>
        <Dialog
          open={showProceedDialog}
          onClose={() => setShowProceedDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
        >
          <DialogContent>
            <div style={{ float: "left", margin: "0 20px 35px 0", height: "100%", fill: "white" }}>
              <WarningIcon className="delete-warning" fontSize="small" />
            </div>
            <DialogContentText id="alert-dialog-description" component="div">
              <div style={{ marginTop: 12, color: '#616161', fontSize: '0.875rem', fontFamily: 'Nunito', fontWeight: 700 }}>
                Are you sure you want to Proceed further ?
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#1A9FE0', textTransform: 'capitalize' }}
              onClick={handleProceed}
              autoFocus
            >
              Yes
            </Button>
            <Button
              style={{ marginRight: 16, fontSize: '0.813rem', fontFamily: 'Nunito', fontWeight: 700, color: '#919191', textTransform: 'capitalize' }}
              onClick={() => setShowProceedDialog(false)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <RejectPopup
        open={openRejectDialog}
        partNo={selectedPartNo}
        mode={rejectMode}
        returnQty={selectedReturnItem?.returnQty || 0}
        rejectionReason={selectedReturnItem?.rejectionReason}
        approvedQty={selectedReturnItem?.approvedQty}
        onClose={() => setOpenRejectDialog(false)}
        onReject={(reason: string, approveQty: number) => {

          if (rejectMode === 'partial') {
            handlePartialApprove(reason, approveQty);
          } else if (rejectMode === 'single') {
            handleReject(reason, approveQty);
          } else if (rejectMode === 'all') {
            handleRejectAll(reason);
          }
        }}
      />
    </div >
  );
}